import styled from 'styled-components'

export const UpgradeButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(254, 209, 48, 1);
  padding: 9px 17px;
  gap: 10px;
  height: 34px;
  margin-right: 24px;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  background: linear-gradient(
    180deg,
    rgba(252, 197, 53, 1) 0%,
    rgba(245, 148, 57, 1) 100%
  );

  transition: all 0.3s;

  &:hover {
    background: linear-gradient(
      0deg,
      rgba(252, 197, 53, 1) 0%,
      rgba(245, 148, 57, 1) 100%
    );
  }

  // This is the animation that is applied to the button

  animation: upgrade-pulse 2s ease 0s infinite normal none running;
  @keyframes upgrade-pulse {
    0% {
      box-shadow:
        rgba(240, 115, 121, 0.3) 0px 1px 6px inset,
        rgb(255, 210, 0) 0px 0px 0px 0px;
    }
    100% {
      box-shadow:
        rgba(240, 115, 121, 0.3) 0px 1px 6px inset,
        rgba(255, 210, 0, 0) 0px 0px 0px 5px;
    }
  }

  // This is the animation that is applied to the crown icon

  svg {
    animation: rotate-scale-up 4s linear 0s infinite normal none running;
  }

  @keyframes rotate-scale-up {
    0% {
      transform: scale(1) rotateY(0deg);
    }
    20% {
      transform: scale(0.9) rotateY(0deg);
    }
    30% {
      transform: scale(1.2) rotateY(180deg);
    }
    40% {
      transform: scale(0.9) rotateY(0deg);
    }
    60%,
    100% {
      transform: scale(1);
    }
  }
`
